import css from './slide-up.module.scss';
import {SlideUpProps} from './slide-up.types';

export const SlideUp = (props: SlideUpProps): JSX.Element => {
	return (
		<div className={css.container}>
			<div className={css.header}>
				<div className={css.title}>{props.title}</div>
				<div className={css.helper}>{props.helper}</div>
			</div>
			{props.children}
		</div>
	);
};
